// Minimal reporter — forwards to Sentry when available, always console.errors.
// P5 — Import DINÂMICO. Um `import * as Sentry` estático puxava o SDK
// inteiro (~70KB) para o main chunk mesmo em rotas que nunca dão erro.
export function reportLovableError(
  error: unknown,
  context?: Record<string, unknown>,
) {
  try {
    console.error(error, context);
    void import("@sentry/react").then((Sentry) =>
      Sentry.captureException(error, { extra: context }),
    );
  } catch {
    /* noop */
  }
}
